/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import { browserHistory } from "react-router";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components

import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import sidebarRoutes from "routes/dashboard.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

import image from "assets/img/sidebar-8-3.jpg";
import aclogo from "assets/img/AccuCASH_Insight_stacked_200px.png";
import cumminsLogo from "assets/img/cummins-transparent-logo149x43.png";

import httpr from "lib/httpRequest";

import { BASE_URL, AUTH_OPTIONS, isLocal, localLicenseRenewDate } from "lib/config";
import { AuthProvider, AuthConsumer } from "react-check-auth";
import ReactLoading from "react-loading";
import LicenseSnackbar from "components/LicenseNotifications/LicenseSnackbar";

import DateFnsUtils from "@date-io/date-fns";
import MuiPickersUtilsProvider from "material-ui-pickers/MuiPickersUtilsProvider";

const switchRoutes = (state) => (
  <Switch>

    { state.licenseAvail ?
        sidebarRoutes.map((prop, key) => {
          if (prop.redirect) {
            return <Redirect from={prop.path} to={prop.to} key={key} />;
          }
          return (
            <Route
              path={prop.path}
              component={withProps(prop.component, state)}
              key={key}
            />
          );
        }) : <div/>
  
    }
  </Switch>
);

function withProps(Component, props) {
  return function(matchProps) {
    return <Component {...props} {...matchProps} />;
  };
}

class App extends React.Component {
  constructor(props) {
    super(props);

    let logo = "";
    if (window.location.hostname.includes("carcr")) {
      logo = cumminsLogo;
    } else {
      logo = aclogo;
    }

    this.state = {
      mobileOpen: false,
      token: null,
      member: null,
      logo: logo,
      licenseAvail: true,
      shouldRefreshAuth: false,
      licenseActivationSuccess: false,
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  getRoute() {
    return this.props.location.pathname !== "/maps";
  }

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  componentDidMount() {
    // if (window.location.href.includes("")) {
    //   const ps = new PerfectScrollbar(this.refs.mainPanel);
    // }
    // window.addEventListener("resize", this.resizeFunction);
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    if(isLocal === "true") {
      this.checkLicense();
    }

    // Check for license activation query parameter
    this.checkLicenseActivation();
  }

  componentDidUpdate() {
    // Check for license activation when component updates
    // This will catch route changes and URL parameter changes
    this.checkLicenseActivation();
  }

  checkLicenseActivation = () => {
    // Check URL for licenseActivated query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const licenseActivated = urlParams.get("licenseActivated");

    if (licenseActivated === "true" && !this.state.shouldRefreshAuth) {
      // Remove query parameter from URL
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);

      // Refresh auth to get updated license data
      // We'll do this in the AuthConsumer where refreshAuth is available
      this.setState({ shouldRefreshAuth: true });
    }
  };
  /*
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }*/

  checkLicense = function() {
    // check license renewal date
    let licenseRenewDate = new Date(localLicenseRenewDate);
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const daysBetween = this.daysBetween(today, licenseRenewDate);
    let message = "";
    const renewalMessage = isLocal === "true" || isLocal === true
      ? "Please click Renew License and follow the instructions to send a renewal token to our support team."
      : "Please contact our support team for renewal.";
    message = "License renewal due in " + daysBetween + " days! \n" + renewalMessage;

    if (daysBetween < 1) {
      const expiredMessage = isLocal === "true" || isLocal === true
        ? "License is expired!\nPlease click Renew License and follow the instructions to send a renewal token to our support team."
        : "License is expired!\nPlease contact our support team for renewal.";
      alert(expiredMessage);
      this.setState({licenseAvail:false});
    } else if (daysBetween < 30) {
      alert(message);
    } 
  }

  daysBetween = function( date1, date2 ) {
    //Get 1 day in milliseconds
    var one_day=1000*60*60*24;
  
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();
  
    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;
  
    // Convert back to days and return
    return Math.round(difference_ms/one_day); 
  }

  hasExpiringOrExpiredLicenses = (userInfo) => {
    if (!userInfo || !userInfo.member || !userInfo.member.LocationLicenses) {
      return false;
    }

    const locationLicenses = userInfo.member.LocationLicenses;
    
    // Check for expired licenses
    const hasExpired = locationLicenses.some(
      loc => loc.license && loc.license.isValid === 0
    );

    // Check for licenses expiring within 30 days
    const hasExpiring = locationLicenses.some(
      loc => loc.license && 
             loc.license.isValid === 1 && 
             loc.license.daysUntilExpiration !== null &&
             loc.license.daysUntilExpiration <= 30 &&
             loc.license.daysUntilExpiration > 0
    );

    return hasExpired || hasExpiring;
  };

  getFilteredRoutes = (userInfo) => {
    const filteredRoutes = [];
    const conditionalRoutes = [];
    const hasLicenseIssues = this.hasExpiringOrExpiredLicenses(userInfo);
    const isLocalInstall = isLocal === "true" || isLocal === true;

    sidebarRoutes.forEach((route) => {
      if (route.path === "/login") {
        return; // Skip login route
      }

      // Skip routes that should be hidden from sidebar
      if (route.hideFromSidebar) {
        return; // Don't show in sidebar, but route is still accessible via URL
      }

      // Only show license management route if:
      // 1. It's a local installation AND
      // 2. There are expiring/expired licenses
      if (route.conditional) {
        if (isLocalInstall && hasLicenseIssues) {
          // Add conditional routes (like Renew License) to the top
          conditionalRoutes.push(route);
        }
        return; // Skip conditional routes that don't meet criteria
      }

      // Include all non-conditional routes
      filteredRoutes.push(route);
    });

    // Put conditional routes (like Renew License) at the top for visibility
    return [...conditionalRoutes, ...filteredRoutes];
  };

  render() {
    const { classes, ...rest } = this.props;
    const { logo } = this.state;

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <AuthProvider
          authUrl={`${BASE_URL}/auth/verify`}
          reqOptions={AUTH_OPTIONS}
        >
          <div className={classes.wrapper}>
            <AuthConsumer>
              {({ isLoading, userInfo, error, refreshAuth }) => {
                // Handle license activation refresh
                if (this.state.shouldRefreshAuth && refreshAuth && userInfo) {
                  // Reset flag and refresh auth
                  this.setState({ shouldRefreshAuth: false, licenseActivationSuccess: true });
                  refreshAuth();
                  
                  // Show success message after a brief delay to allow refresh
                  setTimeout(() => {
                    this.setState({ licenseActivationSuccess: false });
                  }, 5000);
                }

                if (userInfo === null || userInfo === undefined) {
                  return (
                    <Sidebar
                      routes={[sidebarRoutes[0]]}
                      logo={logo}
                      image={image}
                      handleDrawerToggle={this.handleDrawerToggle}
                      open={this.state.mobileOpen}
                      color="green"
                      {...rest}
                    />
                  );
                }
                
                const filteredRoutes = this.getFilteredRoutes(userInfo);
                
                return (
                  <Sidebar
                    routes={filteredRoutes}
                    logo={logo}
                    image={image}
                    handleDrawerToggle={this.handleDrawerToggle}
                    open={this.state.mobileOpen}
                    color="green"
                    {...rest}
                  />
                );
              }}
            </AuthConsumer>

            <div className={classes.mainPanel} ref="mainPanel">
              <AuthConsumer>
                {({ isLoading, userInfo, error }) => {
                  if (userInfo === null || userInfo === undefined) {
                    return (
                      <Header
                        routes={[sidebarRoutes[0]]}
                        handleDrawerToggle={this.handleDrawerToggle}
                        {...rest}
                      />
                    );
                  }
                  
                  const filteredRoutes = this.getFilteredRoutes(userInfo);
                  
                  if (isLocal === "true"){
                    if (!this.state.licenseAvail){
                      alert("License is expired!\nPlease click Renew License and follow the instructions to send a renewal token to our support team.");
                      return (
                        <Header
                          routes={[sidebarRoutes[0]]}
                          handleDrawerToggle={this.handleDrawerToggle}
                          {...rest}
                        />
                      );
                    } else {
                      return (
                        <Header
                          routes={filteredRoutes}
                          handleDrawerToggle={this.handleDrawerToggle}
                          {...rest}
                        />
                      );
                    }
                  } else {
                    return (
                      <Header
                        routes={filteredRoutes}
                        handleDrawerToggle={this.handleDrawerToggle}
                        {...rest}
                      />
                    );
                  }
                }}
              </AuthConsumer>
              <div className={classes.content}>
                <div className={classes.container}>
                  { switchRoutes(this.state) }
                </div>
              </div>
              
              {/* License Activation Success Message */}
              {this.state.licenseActivationSuccess && (
                <div style={{
                  position: "fixed",
                  top: "80px",
                  right: "20px",
                  zIndex: 9999,
                  padding: "15px 20px",
                  backgroundColor: "#4caf50",
                  color: "white",
                  borderRadius: "4px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  maxWidth: "400px"
                }}>
                  <p style={{ margin: 0, fontWeight: "bold" }}>
                    ✓ License successfully activated! License status has been refreshed.
                  </p>
                </div>
              )}
              
              {/* License Notifications - Show for authenticated users */}
              <AuthConsumer>
                {({ userInfo }) => {
                  
                  if (userInfo && userInfo.member && userInfo.member.LocationLicenses) {
                  
                    return (
                      <LicenseSnackbar 
                        locationLicenses={userInfo.member.LocationLicenses} 
                      />
                    );
                  }
           
                  return null;
                }}
              </AuthConsumer>
            </div>

            <AuthConsumer>
              {({ error }) => {
                if (error) {
                  return <Redirect to="/login" />;
                }
              }}
            </AuthConsumer>
          </div>
        </AuthProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(App);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx